import React from 'react'

interface IPortalComponentProps {
  children: React.ReactNode
  title: string
}

const PortalComponent = ({ children, title }: IPortalComponentProps) => {
  return (
    <>
      <div className='bg-green1 rp-component'>
        <h2 className='font-white my0 text-xl weight-700'>{title}</h2>
      </div>
      <div className='rp-component-details'>{children}</div>
    </>
  )
}

export default PortalComponent



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/common/PortalComponent.tsx